// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-E":"E_dpu-detail-E__Tp2f1"};